import { render, staticRenderFns } from "./ConfirmForceUpdateRideInformation.vue?vue&type=template&id=70e2b2c1&scoped=true"
import script from "./ConfirmForceUpdateRideInformation.vue?vue&type=script&lang=js"
export * from "./ConfirmForceUpdateRideInformation.vue?vue&type=script&lang=js"
import style0 from "./ConfirmForceUpdateRideInformation.vue?vue&type=style&index=0&id=70e2b2c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e2b2c1",
  null
  
)

export default component.exports